import { render, staticRenderFns } from "./MemberEditModal.vue?vue&type=template&id=3dc1b2b9&scoped=true"
import script from "./MemberEditModal.vue?vue&type=script&lang=js"
export * from "./MemberEditModal.vue?vue&type=script&lang=js"
import style0 from "./MemberEditModal.vue?vue&type=style&index=0&id=3dc1b2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1b2b9",
  null
  
)

export default component.exports